import { Ident } from '@mode-switch/express';
import { PivotGroup } from './PivotGroup';
import { PivotLevel } from './PivotLevel';
import { PivotQuery } from './PivotQuery';
import { Query } from './Query';
export var PivotDetail;
(function (PivotDetail) {
    function make(model, viewName, pivot) {
        const id = Ident.next();
        let result = {
            id,
            model,
            viewName,
            levels: [],
            parts: [],
            queries: [],
            type: "PIVOT_DETAIL",
        };
        const groups = new Map();
        for (const series of pivot.series || []) {
            let group = PivotGroup.make(series);
            let hasNames = false;
            let hasValues = false;
            const checkNamesAndValues = (field) => {
                switch (field.source) {
                    case "NAMES":
                        hasNames = true;
                        break;
                    case "VALUES":
                        hasValues = true;
                        break;
                }
            };
            for (const field of pivot.column || []) {
                checkNamesAndValues(field);
                group = PivotGroup.Column.add(group, [field]);
            }
            for (const field of pivot.x || []) {
                checkNamesAndValues(field);
                group = PivotGroup.X.add(group, [field]);
            }
            for (const field of pivot.row || []) {
                checkNamesAndValues(field);
                group = PivotGroup.Row.add(group, [field]);
            }
            for (const field of pivot.y || []) {
                checkNamesAndValues(field);
                group = PivotGroup.Y.add(group, [field]);
            }
            if (!PivotGroup.hasField(group, series.field)) {
                checkNamesAndValues(series.field);
                group = PivotGroup.Marks.add(group, [series.field]);
            }
            const markFields = PivotQuery.Marks.fields(series.marks || {});
            for (const field of markFields) {
                checkNamesAndValues(field);
                group = PivotGroup.Marks.add(group, [field]);
            }
            const names = [];
            const values = [];
            if (hasValues) {
                if ((pivot.values || []).length === 0) {
                    names.push(series.field);
                    values.push(series.field);
                }
                else {
                    names.push(...(pivot.values || []));
                    values.push(...(pivot.values || []));
                }
            }
            else if (hasNames) {
                names.push(series.field);
            }
            group = PivotGroup.Names.add(group, names);
            group = PivotGroup.Values.add(group, values);
            for (const sort of pivot.sorts || []) {
                if (PivotGroup.hasField(group, sort.field)) {
                    group = PivotGroup.Sorts.add(group, [sort]);
                }
            }
            groups.set(PivotQuery.Series.name(series), group);
        }
        for (const group of Array.from(groups.values())) {
            const { filters, detail, limit, offset } = pivot;
            const groupSeries = Array.from(group.series.keys());
            const query = Query.Pivot.make({
                name: `detail:series_${groupSeries}`,
                filters,
                detail,
                limit,
                offset,
                column: Array.from(group.column.values()),
                x: Array.from(group.x.values()),
                row: Array.from(group.row.values()),
                y: Array.from(group.y.values()),
                marks: Array.from(group.marks.values()),
                names: Array.from(group.names.values()),
                values: Array.from(group.values.values()),
                sorts: Array.from(group.sorts.values()),
            });
            const levels = Array.from(group.series.values()).map((series) => {
                return PivotLevel.make(series, query);
            });
            result = PivotDetail.Levels.add(result, query, levels);
        }
        return result;
    }
    PivotDetail.make = make;
    function extend(target, source) {
        for (const query of source.queries) {
            const levels = source.levels.filter((level) => level.query === query.name);
            if (levels.length > 0) {
                target = Levels.add(target, query, levels);
            }
        }
        return target;
    }
    PivotDetail.extend = extend;
    let Levels;
    (function (Levels) {
        function add(pivot, query, levels) {
            return {
                ...pivot,
                queries: [...pivot.queries, query],
                levels: [...pivot.levels, ...levels],
            };
        }
        Levels.add = add;
    })(Levels = PivotDetail.Levels || (PivotDetail.Levels = {}));
})(PivotDetail || (PivotDetail = {}));
